import React, { useEffect, useState } from 'react';

import { MediaStreamKind, NetworkQualityScore, SlotType } from '@yandex-video-platform/goloom-sdk';
import { ParticipantControlsLayerRendererProps } from '@yandex-video-platform/goloom-sdk-react';

import { getNetworkQualityTypeByScore } from '../../../helpers/get-network-quality-type-by-score';
import { hasVideoLimitation } from '../../../helpers/video-limitation';
import { ParticipantLayer } from './participant-layer';

export const ParticipantControlsLayer: React.FC<ParticipantControlsLayerRendererProps> = (props) => {
    const { videoElementRef, participant, isVideoReady, slot, slotIndex } = props;

    const [networkQualityType, setNetworkQualityType] = useState(
        getNetworkQualityTypeByScore(participant.networkScore)
    );
    useEffect(() => {
        // Игнорируем неизвестное состояние, чтобы не врать пользователю
        if (participant.networkScore === NetworkQualityScore.NETWORK_QUALITY_SCORE_UNSPECIFIED) {
            return;
        }

        setNetworkQualityType(getNetworkQualityTypeByScore(participant.networkScore));
    }, [participant.networkScore]);

    if (slot.type !== SlotType.PARTICIPANT) {
        return null;
    }

    const { mediaStreamKind, vad, limitationReason } = slot;

    const isScreenSharing = mediaStreamKind === MediaStreamKind.DISPLAY;
    const isCamera = mediaStreamKind === MediaStreamKind.DEVICES;
    const videoLimitation = hasVideoLimitation(limitationReason);

    return (
        <ParticipantLayer
            userId={participant.userId}
            isVAD={Boolean(vad)}
            isScreenSharing={isScreenSharing}
            isCameraEnabled={isCamera && participant.sendVideo}
            isVideoReady={isVideoReady}
            videoElementRef={videoElementRef?.current}
            videoLimitation={videoLimitation}
            networkQualityType={networkQualityType}
            slotIndex={slotIndex}
        />
    );
};
